<div class="p-6">
  <h1 class="textTabsColor mb-4 text-2xl font-bold" i18n="@@userProductsTitle">Products</h1>
  <app-product-list-component />
</div>
